import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger';

import Persistence from './persistence';
import reducers from '../reducers';
import {IS_DEV} from '../config'

const devTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

export default onComplete => {
  const middleware = [thunk];
  const enhancers = [];

  if (IS_DEV) middleware.push(createLogger({collapsed: true, duration: true}));

  const persistentReducer = Persistence.combineReducers(reducers);
  enhancers.push(applyMiddleware(...middleware));

  const composeFn = devTools || compose;
  const store = createStore(persistentReducer, composeFn(...enhancers));
  if (Persistence.isActive()) {
    Persistence.updateReducers(store, onComplete);
  } else {
    setTimeout(onComplete);
  }

  return store;
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js